import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from './apiClient';

const moduleKeys = {
  all: ['modules'],
  lists: () => [...moduleKeys.all, 'list'],
  details: () => [...moduleKeys.all, 'detail'],
  detail: (id) => [...moduleKeys.details(), id],
};

export const useModules = () => {
  return useQuery({
    queryKey: moduleKeys.lists(),
    queryFn: async () => {
      const response = await apiClient.get('modules');
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });
};

export const useModule = (id, options = {}) => {
  return useQuery({
    queryKey: moduleKeys.detail(id),
    queryFn: async () => {
      const response = await apiClient.get(`module/${id}`);
      return response.data;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};

export const useCreateModule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (moduleData) => {
      const response = await apiClient.post('modules', moduleData);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: moduleKeys.lists() });
    },
    onError: (error) => {
      console.error('Error creating module:', error);
    },
  });
};

export const useDeleteModule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const response = await apiClient.delete(`module/${id}`);
      return response.data;
    },
    onSuccess: (data, deletedId) => {
      queryClient.invalidateQueries({ queryKey: moduleKeys.lists() });
      queryClient.removeQueries({ queryKey: moduleKeys.detail(deletedId) });
    },
    onError: (error) => {
      console.error('Error deleting module:', error);
    },
  });
};
